import { render, staticRenderFns } from "./delMonitor.vue?vue&type=template&id=f664aa3a&scoped=true"
import script from "./delMonitor.vue?vue&type=script&lang=js"
export * from "./delMonitor.vue?vue&type=script&lang=js"
import style0 from "./delMonitor.vue?vue&type=style&index=0&id=f664aa3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f664aa3a",
  null
  
)

export default component.exports